import { LOCIZE_NS, Languages } from '@avanta/shared/constants/common';
import { type PATIENT_SERVICES } from '@avanta/shared/constants/patients';
import { type UserType } from '@avanta/shared/constants/users';
import { type BaseUser } from './users';

export const DEFAULT_LANGUAGE = Languages.Spanish;

export interface Patient extends BaseUser {
  activeServices: (typeof PATIENT_SERVICES)[keyof typeof PATIENT_SERVICES][];
  age: number;
  amountExpendAsPatient: number;
  appLanguage: string;
  backofficeUserId: number | null;
  canBookAppointments: boolean;
  contactPhone: string;
  country: string;
  departmentId?: string | null;
  emailNotificationActive: boolean;
  enterpriseId: string;
  firstName: string;
  hasCopaid: boolean;
  gender: number;
  grantedSessionsThisMonth: number;
  grantedSessionsThisYear: number;
  dayOfBirth: number;
  monthOfBirth: number;
  nickname: string;
  nif: string;
  paidUser: boolean;
  profileCompleteToBookAppointments: boolean;
  pushNotificationActive: boolean;
  requiredProfileSetup: boolean;
  remainingSessionsThisMonth: number;
  spokenLanguages: Languages[];
  surname: string;
  timeZone: string;
  totalAmountOfSessions: number;
  type: UserType.PATIENT;
  yearOfBirth: number;
}

export enum Gender {
  Female = 0,
  Male = 1,
  PreferNot = 2,
}

export const genderOptions = [
  {
    value: Gender.Female,
    label: 'ProfileSettings.Form.gender.options.female',
    ns: LOCIZE_NS.PROFILE,
  },
  {
    value: Gender.Male,
    label: 'ProfileSettings.Form.gender.options.male',
    ns: LOCIZE_NS.PROFILE,
  },
  {
    value: Gender.PreferNot,
    label: 'ProfileSettings.Form.gender.options.preferNot',
    ns: LOCIZE_NS.PROFILE,
  },
];
